import { render, staticRenderFns } from "./noti-item.vue?vue&type=template&id=094545d8&"
import script from "./noti-item.vue?vue&type=script&lang=js&"
export * from "./noti-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports